import { useTranslation } from 'react-i18next';
import Tag from './Tag';
import { cn } from '../../../utils/string/cn.utils';
import { STATUS_OPTIONS } from '../../../constants/constant';

const RenderFulfillmentHistoryStatusTag = ({
  orderType,
  status,
  className,
}) => {
  const { t } = useTranslation();
  // 0: Đã tạo đơn hàng
  // 1: Xác nhận đơn hàng
  // 2: Đang sản xuất
  // 3: Đóng gói
  // 4: Vận chuyển
  // 5: Giao hàng
  // 6: Thi công / lắp đặt
  // 7: Bà giao
  const label = t(STATUS_OPTIONS[status]);
  switch (status) {
    // case 0:
    //   return (
    //     <Tag
    //       className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD] ${className}`}
    //       label={
    //         <span className="truncate text-label-medium font-semibold text-[#258FD2]">
    //           {t(STATUS_OPTIONS[status])}
    //         </span>
    //       }
    //     />
    //   );
    // case 1:
    //   return (
    //     <Tag
    //       className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD] ${className}`}
    //       label={
    //         <span className="truncate text-label-medium font-semibold text-[#258FD2]">
    //           {t(STATUS_OPTIONS[status])}
    //         </span>
    //       }
    //     />
    //   );
    // case 2:
    //   return (
    //     <Tag
    //       className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD] ${className}`}
    //       label={
    //         <span className="truncate text-label-medium font-semibold text-[#258FD2]">
    //           {t(STATUS_OPTIONS[status])}
    //         </span>
    //       }
    //     />
    //   );
    // case 3:
    //   return (
    //     <Tag
    //       className={`flex py-[4px] px-[6px] w-fit items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD] ${className}`}
    //       label={
    //         <span className="truncate text-label-medium w-fit font-semibold text-[#258FD2]">
    //           {t(STATUS_OPTIONS[status])}
    //         </span>
    //       }
    //     />
    //   );
    // case 4:
    //   return (
    //     <Tag
    //       className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD] ${className}`}
    //       label={
    //         <span className="truncate text-label-medium font-semibold text-[#258FD2]">
    //           {t(STATUS_OPTIONS[status])}
    //         </span>
    //       }
    //     />
    //   );
    // case 5:
    //   return (
    //     <Tag
    //       className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD] ${className}`}
    //       label={
    //         <span className="text-label-medium font-semibold text-[#258FD2]">
    //           {t(STATUS_OPTIONS[status])}
    //         </span>
    //       }
    //     />
    //   );
    // case 6:
    //   return (
    //     <Tag
    //       className={cn(
    //         `flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD]`,
    //         className,
    //         // orderType === 2 ? 'border-[#3ABB2C] bg-[#F3FCF1]' : ''
    //       )}
    //       label={
    //         <span
    //           className={cn(
    //             'text-label-medium font-semibold text-[#258FD2] truncate line-clamp-1',
    //             // orderType === 2 ? 'text-[#3ABB2C]' : ''
    //           )}
    //         >
    //           {label}
    //         </span>
    //       }
    //     />
    //   );
    case 6:
      return (
        <Tag
          className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#3ABB2C] bg-[#F3FCF1] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-[#3ABB2C] truncate line-clamp-1">
              {label}
            </span>
          }
        />
      );
    case 8:
      return (
        <Tag
          className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#E05364] bg-[#FDF5F3] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-[#E5654E] truncate line-clamp-1">
              {t('Order cancelled')}
            </span>
          }
        />
      );
    default:
      return (
        <Tag
          className={`flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] border-[1px] border-solid border-[#258FD2] bg-[#F2F8FD] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-[#258FD2] truncate line-clamp-1">
              {t(STATUS_OPTIONS[status])}
            </span>
          }
        />
      );
  }
};
export default RenderFulfillmentHistoryStatusTag;
